import React from "react";
import ReactECharts from "echarts-for-react";

export default function TopCategoriesDonut({ data }) {

  const palette = ["#ff7a00", "#3a3a3a", "#fde7d8", "#f7c9a5", "#d9c1a8", "#a6a19a"];

 const option = {
  color: palette,
  tooltip: { trigger: "item" },
  legend: { show: false },
  series: [{
  type: "pie",
  radius: ["40%", "54%"],
  center: ["45%", "30%"], 
  labelLine: { show: true },
  itemStyle: { borderColor: "#fff", borderWidth: 4 },
  data: data.seriesData.map(x => ({ name: x.name, value: x.value })),
}]
};


  return (
    <>
      <div className="card-title-row">
        <div className="card-title">Top Categories</div>
        {/* <div className="card-subtitle">{data.label}</div> */}
      </div>

      <div className="echart">
        <ReactECharts option={option} notMerge lazyUpdate />
      </div>

      
      <ul className="legend-inline">
        {data.seriesData.map((x, i) => (
          <li key={x.name}>
            <span
              className="legend-dot"
              style={{ background: palette[i % palette.length] }}
            />
            <span className="legend-name">{x.name}</span>
            <b>{x.value}%</b>
          </li>
        ))}
      </ul>
    </>
  );
}
